import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 20.738 20.738",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.738 20.738\" id=\"arrow-left\"><path d=\"M20.738 9.073H4.964l7.246-7.245L10.369 0 0 10.369l10.369 10.369 1.831-1.827-7.236-7.246h15.774Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol